import React, { useState } from "react";
import { message } from "antd";
import DetailsCard from "./DetailsCard";
import InlineEditableNameCell from "./InlineEditableNameCell";
import { formatUSPhoneNumber } from "../../../../utils/formatters";
import useGoto from "../../../../hooks/useGoto";

const PhoneNumberDetails = ({
  phoneData,
  onAssignUser,
  onAssignExtension,
  onAssignDepartment,
  onAssignLocation,
  refetch,
  canAssignLocation,
}) => {
  const [editingName, setEditingName] = useState(false);
  const [currentName, setCurrentName] = useState(phoneData?.name);

  const { updatePhoneNumber, loading: updatingPhoneNumberLoading } = useGoto({
    operation: "updatePhoneNumber",
    onCompleted: async data => {
      message.success(data?.updateCallPhoneNumber?.message);
      setEditingName(false);
      if (refetch) {
        await refetch();
      }
    },
    onError: err => {
      console.error("Error updating phone number:", err);
    },
  });

  // Simple details object - using the same fields as the table
  const details = {
    "Phone number": phoneData?.phoneNumber ? formatUSPhoneNumber(phoneData.phoneNumber) : "--",
    Name: editingName ? (
      <InlineEditableNameCell
        value={currentName}
        record={phoneData}
        placeholder="Name"
        editing={editingName}
        loading={updatingPhoneNumberLoading}
        onStartEdit={() => setEditingName(true)}
        onSave={async newName => {
          setCurrentName(newName);
          await updatePhoneNumber({
            variables: {
              phoneNumberId: phoneData.id,
              name: newName,
            },
          });
        }}
        onCancel={() => {
          setEditingName(false);
        }}
      />
    ) : (
      currentName || "--"
    ),
    "EAI user": phoneData?.user?.fullName || null,
    Extension: phoneData?.callExtension?.number || null,
    Department: phoneData?.departmentLevel || null,
    ...(canAssignLocation && { Location: phoneData?.originalLocation?.title || null }),
    "Caller ID name": phoneData?.callerName || "--",
  };

  const handleEdit = fieldKey => {
    if (fieldKey === "EAI user") {
      if (onAssignUser) onAssignUser();
    } else if (fieldKey === "Extension") {
      if (onAssignExtension) onAssignExtension();
    } else if (fieldKey === "Department") {
      if (onAssignDepartment) onAssignDepartment();
    } else if (fieldKey === "Location") {
      if (onAssignLocation) onAssignLocation();
    } else if (fieldKey === "Name") {
      setEditingName(true);
    }
  };

  return (
    <div className="mb-4">
      {/* Phone details using DetailsCard */}
      <DetailsCard
        title="Details"
        details={details}
        editableFields={["Name", "EAI user", "Extension", "Department", "Location"]}
        onEdit={handleEdit}
      />
    </div>
  );
};

export default PhoneNumberDetails;
